import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Maslo() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isPasswordForget, setIsPasswordForget] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetPasswordCreated, setResetPasswordCreated] = useState('');

  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Двете полиња се задолжителни");
      return;
    }

    const loginData = {
      "username": username,
      "password": password
    }

    setLoading(true);

    const response = await fetch(`${API_URL}/account/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',  // Specify the content type
      },
      body: JSON.stringify(loginData),
    })

    if (response.ok) {
      const data = await response.json();

      localStorage.setItem("authToken", data.token);
      setError("");
      toast.success(<span>Успешно се логиравте.</span>);
      setLoading(false);
      navigate('/wrongPage');
    }
    else {
      setError("Невалидно корисничко име или лозинка!");
      setLoading(false);
    }
  };

  const handleForgetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Емаил полето е задолжително");
      return;
    }

    const emailData = {
      "email": email
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/account/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',  // Specify the content type
        },
        body: JSON.stringify(emailData),
      })

      if (response.ok) {
        setLoading(false);
        setResetPasswordCreated('Линкот за промена на пасворд е пратен на вашиот емаил.')
      }
      else {
        setLoading(false);
        setError('Настана проблем при промената на пасвордот', error)
      }
    }
    catch (error) {
      setLoading(false);
      setError('Настана проблем при промената на пасвордот')
    }


  }

  return (
    <div>
      <div className="flex justify-center items-center min-h-[50vh] bg-gray-100">
        <div className="w-full max-w-sm p-6 bg-white rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">
            Login
          </h2>

          {!isPasswordForget && <form onSubmit={handleSubmit} className="space-y-4">
            <div className="form-control">
              <label htmlFor="username" className="label">
                <span className="label-text">Корисничко име</span>
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="input input-bordered w-full"
                placeholder="Внеси корисничко име"
              />
            </div>

            <div className="form-control">
              <label htmlFor="password" className="label">
                <span className="label-text">Лозинка</span>
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input input-bordered w-full"
                placeholder="Внеси лозинка"
              />
            </div>

            {error && (
              <div className="text-red-500 text-sm mt-2">
                <p>{error}</p>
              </div>
            )}
            <button
              type="submit"
              className="btn btn-primary w-full mt-4"
              disabled={loading}
            >
              Логирај се
              {loading && (<span className="loading loading-spinner loading-xs"></span>)}
            </button>
          </form>}
          {isPasswordForget && <form onSubmit={handleForgetPassword} className="space-y-4">
            <div className="form-control">
              <label htmlFor="email" className="label">
                <span className="label-text">Емаил</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input input-bordered w-full"
                placeholder="Внеси емаил"
              />
            </div>
            {resetPasswordCreated && (
              <div className="text-green-500 text-sm mt-2">
                <p>{resetPasswordCreated}</p>
              </div>
            )}
            <button
              type="submit"
              className="btn btn-primary w-full mt-4"
              disabled={loading}
            >
              Прати
              {loading && (<span className="loading loading-spinner loading-xs"></span>)}
            </button>
          </form>}
          <div className="w-full text-center" >
            <p className="text-blue-400 hover:text-blue-600 hover:cursor-pointer hover:underline items-center"
              onClick={() => setIsPasswordForget(!isPasswordForget)}>
              {isPasswordForget ? 'Врати се назад' : 'Заборавена лозинка'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Maslo
